export default "__VITE_ASSET__CC7r1qrx__"